import { useState } from 'react'

import { isAxiosError } from 'axios'

import { type DefaultApi, ErrorResponse } from '@infura/packages.api'

import { api } from 'lib/api/api'
import { _GetTypedParams, _GetTypedReturn } from 'lib/api/utils'

export function useApiClient<TMethodName extends keyof DefaultApi, TMethod extends DefaultApi[TMethodName]>(
  operation: TMethodName
) {
  const [state, setState] = useState<{
    data?: _GetTypedReturn<TMethod>
    error?: ErrorResponse
    loading: boolean
    called: boolean
  }>({
    called: false,
    // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
    data: null,
    // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
    error: null,
    loading: false
  })
  const bind =
    (...args: _GetTypedParams<TMethod>) =>
    async (e?: React.MouseEvent) => {
      if (e) e.preventDefault()
      try {
        // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
        setState(s => ({ ...s, called: true, error: null, loading: true }))
        const d = (await (api[operation] as any)(...args)).data
        // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
        setState(s => ({ ...s, data: d, error: null, loading: false }))
        return d
      } catch (e: any) {
        // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
        if (isAxiosError(e)) setState(s => ({ ...s, data: null, error: e.response.data, loading: false }))
        // @ts-expect-error enabled to support strictNullChecks - Please fix this if you can!
        else setState(s => ({ ...s, data: null, error: e, loading: false }))
      }
    }

  const call = (...args: _GetTypedParams<TMethod>) => {
    return bind(...args)()
  }

  return {
    bind,
    call,
    ...state
  }
}
